/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
}));

export default function AlertField(props) {
  const classes = useStyles();
  const hidden = props.uiSchema?.['ui:hidden'];
  return hidden ? null : (
    <div className={classes.root}>
      <Alert severity="info">
        <span dangerouslySetInnerHTML={{ __html: props.schema?.text }} />
      </Alert>
    </div>
  );
}
